import { render, staticRenderFns } from "./LoginV2.vue?vue&type=template&id=028c5bdc&scoped=true&"
import script from "./LoginV2.vue?vue&type=script&lang=ts&"
export * from "./LoginV2.vue?vue&type=script&lang=ts&"
import style0 from "./LoginV2.vue?vue&type=style&index=0&id=028c5bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c5bdc",
  null
  
)

export default component.exports